export default {
    home: "Inici",
    projects: "Cursos",
    community: "Comunitat",
    customization: "Personalització",
    reports: "Informes",
    marketing: "Màrqueting",
    settings: "Ajustaments",
    my_account: 'El meu compte',
    annual_sales: "Vendes (Any)",
    sales: "Vendes",
    students: "Estudiants",
    teachers: "Docents",
    products: "Productes",
    project: "Projectes",
    categories: "Categories",
    category: 'Categoria',
    published: "Publicat",
    name: "Nom",
    lastname: 'Cognoms',
    email: "Email",
    phone: "Telèfon",
    title: "Títol",
    pass: 'Contrasenya',
    pass_confirm: 'Confirmació de contrasenya',
    coming_soon: "Próximamente",
    month: "Mes",
    year: "Any",
    date: "Data",
    plan: 'Pla',
    pvp: "PVP",
    net: "Net",
    total: 'Total',
    state: "Estat",
    delete: "Eliminar",
    profile: "Perfil",
    enrollments: "Matriculacions",
    cancel: "Cancel·la",
    save: "Desa",
    remove: 'Esborrar',
    email_address: 'Adreça de correu',
    image_format: 'PNG, JPG, GIF fins a 3MB',
    close: 'Tancar',
    back: 'Tornar',
    coming_soon_brainspro: 'Properament a Brainspro',
    and: 'i',
    product: "Producte",
    date_creation: 'Data de creació',
    type: 'tipus',

    //AppComponent
    my_profile: 'El meu perfil',
    adjust: 'Ajustaments',
    out: 'Sortir',
    search: 'Cerca',
    academy_preview: 'Previsualitzar acadèmia',
    my_academy: 'La meva Acadèmia',
    new_project: 'Nou Curs',
    text_current_period: 'El teu període de prova ',
    text_end_at: ' acaba a ',
    plans: 'Plans de Suscripció',
    billing: 'Facturació',

    //ThankYouPageComponent
    thankyou: 'Gràcies!',
    go_to_academy: "Anar a l'acadèmia",

    //NavigationDesktop - Mobile
    records: 'Enregistraments',
    videos: 'Videos',

    //Aviso de cambios sin guardar (FE-032)
    unsaved_changes_title: 'Tens canvis sense desar',
    unsaved_changes_text: 'Si surts ara, es perdran els canvis que no has desat.',
    unsaved_changes_leave: 'Sortir sense desar',
    unsaved_changes_stay: 'Continuar editant',

    // FE-043 · RouteTabsComponent
    tabs: 'Pestanyes',

    // Botón Aula (Moodle)
    classroom_ready_title: "L'aula està a punt",
    classroom_ready_text: 'El navegador ha bloquejat la pestanya nova. Prem «Obrir aula» per entrar al curs.',
    classroom_open: 'Obrir aula',
    classroom_timeout: "Moodle està trigant massa a respondre. Torna-ho a provar d'aquí a uns minuts.",
    classroom_error: "No s'ha pogut obrir l'aula del curs.",

    // Menú de navegación
    users: 'Usuaris',
    navigation_menu: 'Menú de navegació',
    open_menu: 'Obrir menú',
    close_menu: 'Tancar menú',
}
